var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"257px"}},[_c('a-select',{staticStyle:{"width":"98%"},attrs:{"showSearch":"","mode":_vm.multiple ? 'multiple' : 'default',"optionFilterProp":"children","maxTagTextLength":17,"maxTagCount":1,"placeholder":_vm.$t('filter_by_branch'),"options":_vm.options.map(el => ({
          value: el.branch_id,
          id: el.branch_id,
          label: el.branch_name_en
        })),"filterOption":(input, option) =>
          option.componentOptions.children[0].text
            .toLowerCase()
            .indexOf(input.toLowerCase()) >= 0},on:{"change":_vm.changeValue},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }